import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarPrecoPublicoDs,
  criarContribuinteDs,
  criarPermissionariosDs,
} from "../../DataSources";
import uiInfo from "../../ui-info";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import Memoria from "../../Memoria";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  contribuinteSequencial: undefined,
  precoPublicoId: undefined,
  baseCalculo: undefined,
  lojaBox: "",
  galpao: "",
  popupContribuinteVisivel: false,
};

export default class PermissionarioForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.permissionariosDs = criarPermissionariosDs();
    this.contribuinteDs = criarContribuinteDs();
    this.precoPublicoDs = criarPrecoPublicoDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.precoPublicoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarPrecoPublicoDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };

    //Funções do contribuinte
    /*
    /*
    */
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteSeq,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    this.setNomeContribuinteErro = this.setNomeContribuinteErro.bind(this);
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
    /*
   /*
   */
    //Fim da funções do contribuinte
  }

  //Funções do contribuinte
  /*
  /*
  */

  setContribuinteId(data) {
    console.log(data);
    this.setState({ contribuinteSeq: data.value });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({
        filter: [["sequencial", "=", this.state.contribuinteSeq]],
      })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeContribuinte(result[0]);
        } else {
          this.setNomeContribuinte(undefined);
        }
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinte(contribuinte) {
    if (contribuinte === undefined) {
      this.setState({ _uiNomeContribuinte: "", contribuinteId: null });
    } else {
      this.setState({
        _uiNomeContribuinte: contribuinte.nome,
        contribuinteId: contribuinte.id,
      });
    }
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteSeq: e.row.data.sequencial,
      contribuinteId: e.row.data.id,
      popupContribuinteVisivel: false,
    });
    this.atualizarNomeContribuinte();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupContribuinteVisivel: true });
  }
  /*
/*
*/
  //Fim da funções do contribuinte

  componentDidMount() {
    _cadastroCorrente = Memoria.resturarEstado(
      this.props.location,
      _cadastroCorrente,
      _versaoCadastro
    );

    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.permissionariosDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("Permissionário não encontrado.", "error");
              this.props.history.push("/permissionarios");
            }
            this.setState({
              id: data.id,
              contribuinteSeq: data.contribuinte.sequencial,
              _uiNomeContribuinte: data.contribuinte.nome,
              prefeituraId: data.prefeituraId,
              contribuinteId: data.contribuinteId,
              precoPublicoId: data.precoPublicoId,
              baseCalculo: data.baseCalculo,
              lojaBox: data.lojaBox,
              galpao: data.galpao,
            });
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="PERMISSIONÁRIO" colSpan={2} colCount={4}>
              <SimpleItem colSpan={4} component={this.renderContribuinte}>
                <Label text="Contribuinte" />
              </SimpleItem>
              <SimpleItem
                dataField={"precoPublicoId"}
                editorType={"dxLookup"}
                editorOptions={this.precoPublicoOptions}
                colSpan={3}
              >
                <Label text="Preço Público" />
              </SimpleItem>
              <SimpleItem
                dataField={"baseCalculo"}
                editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                }}
                colSpan={1}
              >
                <Label text="Base de Cálculo" />
              </SimpleItem>
              <SimpleItem dataField={"lojaBox"} colSpan={2}>
                <Label text="Loja Box" />
              </SimpleItem>
              <SimpleItem dataField={"galpao"} colSpan={2}>
                <Label text="Galpão" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupContribuinteVisivel}
          onHiding={() => this.setState({ popupContribuinteVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupContribuinteVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.permissionariosDs, entidade)
      .then(
        function () {
          notify("Permissionário cadastrada com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          Memoria.removerEdicao(this.props.location);
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        if (error.response) {
          ShowError(error.response.data);
        }
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
